import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { AlertTriangle, Car, CalendarClock, FileText, Wallet, ChevronRight } from "lucide-react";

const META = {
  kendaraan: { icon: Car, cls: "text-red-600 bg-red-100" },
  jatuh_tempo: { icon: CalendarClock, cls: "text-amber-600 bg-amber-100" },
  pengajuan: { icon: FileText, cls: "text-sky-600 bg-sky-100" },
  estimasi_kas: { icon: Wallet, cls: "text-emerald-700 bg-emerald-100" },
};

export function ActionNeeded() {
  const navigate = useNavigate();
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/dashboard/action-items").then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data) return null;
  const tiles = data.tiles || [];

  return (
    <Card className="p-4 border-2 border-red-300 bg-rose-50 h-full" data-testid="action-needed-section">
      <div className="flex items-center gap-2 mb-3">
        <AlertTriangle className="h-5 w-5 text-red-600" />
        <h3 className="font-semibold text-red-800" style={{ fontFamily: "Outfit" }}>{data.title}</h3>
      </div>
      <div className={`grid grid-cols-2 ${tiles.length >= 4 ? "xl:grid-cols-4" : tiles.length === 3 ? "xl:grid-cols-3" : ""} gap-3`}>
        {tiles.map((t) => {
          const m = META[t.key] || META.pengajuan;
          const Icon = m.icon;
          return (
            <button key={t.key} onClick={() => navigate(t.link)} data-testid={`action-tile-${t.key}`}
              className="group text-left rounded-xl border border-red-200 bg-white p-3.5 hover:border-red-400 hover:shadow-md transition-[box-shadow,border-color] duration-200">
              <div className="flex items-center justify-between">
                <span className={`h-8 w-8 rounded-lg flex items-center justify-center ${m.cls}`}><Icon className="h-4 w-4" /></span>
                <ChevronRight className="h-4 w-4 text-muted-foreground group-hover:translate-x-0.5 transition-transform" />
              </div>
              <p className="text-xs text-muted-foreground mt-2.5">{t.label}</p>
              <p className="text-lg sm:text-xl font-bold font-mono truncate" data-testid={`action-tile-${t.key}-value`}>{t.value}</p>
              <p className="text-[11px] text-muted-foreground truncate">{t.sub}</p>
            </button>
          );
        })}
      </div>
    </Card>
  );
}
